/* eslint-disable */
import { isEmpty, get } from 'lodash';
import tmsApi from './../api/tmsApi';
import helper from './helper';

const { getActiveParam, createInputParam, stringify } = helper;

export default {
  namespaced: true,
  state: {
    preferences: {},
    dataState: {
      users: 'LOADING',
    },
    users: [],
    detailData: null,
    assignedVehicleData: null,
    detailDataId: null,
    detailLoaded: false,
    assignVehicleLoaded: false,
    dataLoaded: false,
    count_info: {
      all: 0,
      default: 0,
      system_admin: 0,
      admin: 0,
      active: 0,
      inactive: 0,
      vehicle: 0,
    },
    query: {
      search: '',
      company_id: null,
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'FULL_NAME',
        direction: 'ASC',
      },
      type: null,
      active: 'all',
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.users.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.users.push(data);
    },
    REPLACE_DATA(state, users) {
      state.users.splice(0, state.users.length, ...users);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'FULL_NAME';
      query.sort.direction = 'ASC';
      query.type = null;
      query.active = 'all';
    },
    SET_COMPANY_ID(state, id) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.company_id = id;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_QUERY_TYPE(state, type) {
      state.query.type = type;
    },
    SET_QUERY_ACTIVE(state, active) {
      state.query.active = active;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      state.count_info.default = 0;
      state.count_info.system_admin = 0;
      state.count_info.admin = 0;
      state.count_info.active = 0;
      state.count_info.inactive = 0;
      state.count_info.vehicle = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.type === 'DEFAULT') {
          if (c.is_vehicle) {
            state.count_info.vehicle += c.count;
          } else {
            state.count_info.default += c.count;
          }
        } else if (c.type === 'SYSTEM_ADMIN') {
          state.count_info.system_admin += c.count;
        } else if (c.type === 'ADMIN') {
          state.count_info.admin += c.count;
        }
        if (c.active) {
          state.count_info.active += c.count;
        } else {
          state.count_info.inactive += c.count;
        }
      }, this);
    },
    SET_DETAIL_NOT_LOADED(state) {
      state.detailLoaded = false;
    },
    SET_DETAIL_LOADED(state) {
      state.detailLoaded = true;
    },
    SET_ASSIGNED_VEHICLE_NOT_LOADED(state) {
      state.detailLoaded = false;
    },
    SET_ASSIGNED_VEHICLE_LOADED(state) {
      state.detailLoaded = true;
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    SET_ASSIGNED_VEHICLE_DATA(state, data) {
      state.assignedVehicleData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.users.findIndex(user => user.id === id);
      state.users.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_USERS({ dataState }, state) {
      dataState.users = state;
    },
    ADD_PREFERENCES_DATA(state, data) {
      state.preferences = data;
    },
  },
  getters: {
    users(state) {
      return state.users;
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_default(state) {
      return state.count_info.default;
    },
    count_vehicle(state) {
      return state.count_info.vehicle;
    },
    count_system_admin(state) {
      return state.count_info.system_admin;
    },
    count_admin(state) {
      return state.count_info.admin;
    },
    count_active(state) {
      return state.count_info.active;
    },
    count_inactive(state) {
      return state.count_info.inactive;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    get_assigned_vehicle_data(state) {
      return state.assignedVehicleData || [];
    },
    detailLoaded(state) {
      return state.detailLoaded;
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    dataStateUsers(state) {
      return state.dataState.users;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const active = getActiveParam(state);
      const companyId = createInputParam(state.query, 'company_id', false);

      let isVehicle = '';
      let type = createInputParam(state.query, 'type', false);
      if (type) {
        if (state.query.type === 'VEHICLE') {
          type = createInputParam({ type: 'DEFAULT' }, 'type', false);
          isVehicle = 'is_vehicle: true';
        } else if (state.query.type === 'DEFAULT') {
          isVehicle = 'is_vehicle: false';
        }
      }

      let searchQuery = '';
      if (typeof state.query.search === 'string' && state.query.search.trim().length) {
        const q = state.query.search.trim();
        searchQuery = `query: "${q}"`;
      }
      const query = `
        {
          users(
            offset: ${offset},
            limit: ${limit},
            ${searchQuery}
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${active}
            ${companyId}
            ${isVehicle}
          ) {
            id
            type
            full_name
            username
            email
            avatar
            active
            created_at
            company {
              id
            }
            vehicle {
              reg_no
            }
            employee {
              name
              type
            }
          }
        }
      `;
      // commit('CLEAR_DATA');
      // commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_USERS', 'LOADING');
      return api(query, 'users').then(({ data }) => {
        const { users } = data;
        commit('REPLACE_DATA', users);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_USERS', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_USERS', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const query = `
        {
          user_info(
            query: "${state.query.search}"
            ${companyId}
          ) {
            type
            active
            count
            is_vehicle
          }
        }
      `;
      // commit('CLEAR_DATA');
      return api(query, 'user_info').then(({ data }) => {
        const { user_info } = data;
        commit('SET_COUNT_INFO', user_info);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const active = getActiveParam(state);
      const companyId = state.query.company_id === null
        ? '' : `company_id: ${state.query.company_id}`;
      const type = state.query.type === null
        ? '' : `type: ${state.query.type}`;
      const query = `
        {
          users: find_users(
            query: "${state.query.search}",
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${active}
            ${companyId}
          ) {
            id
            type
            full_name
            username
            email
            avatar
            active
            vehicle {
              reg_no
            }
            employee {
              name
              type
            }
            created_at
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_users').then(({ data }) => {
        const { users } = data;
        users.forEach((user) => {
          commit('ADD_DATA_ON_LIST', user);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({
      state, commit, rootState,
    }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          user(id: ${state.detailDataId}) {
            id
            username
            full_name
            email
            type
            avatar
            address {
              country
              state
              city
              address1
              address2
              zip_code
              latitude
              longitude
            }
            company {
              id
              name
              type
            }
            vehicle {
              reg_no
            }
            employee {
              name
              type
            }
            account
            metadata
            created_at
          }
        }
      `;
      commit('SET_DETAIL_NOT_LOADED');
      return api(query, 'user').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.user);
        commit('SET_DETAIL_LOADED');
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    LOAD_ASSIGNED_VEHICLE({
      state, commit, rootState,
    }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          user(id: ${state.detailDataId}) {
            assigned_vehicle {
              id
              reg_no
            }
          }
        }
      `;
      commit('SET_ASSIGNED_VEHICLE_NOT_LOADED');
      return api(query, 'get_assigned_vehicle').then(({ data }) => {
        const { assigned_vehicle } = data.user;
        commit('SET_ASSIGNED_VEHICLE_DATA', assigned_vehicle);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_ASSIGNED_VEHICLE');
      });
    },
    UPDATE_DATA({
      state, commit, rootState, rootGetters,
    }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const query = `
        mutation CreateUpdateUser($id: ID!, $input: UserUpdateInput) {
          user: update_user(id: $id, input: $input) {
            id
            username
            full_name
            email
            type
            address {
              country
              state
              city
              address1
              address2
              zip_code
              latitude
              longitude
            }
            company {
              id
              name
              type
            }
            vehicle {
              reg_no
            }
            employee {
              name
              type
            }
            metadata
            created_at
          }
        }`;

      const {
        username,
        full_name,
        password,
        email,
        type,
        company_id,
        metadata,
        address,
      } = payloads;

      const employee = rootGetters['employees/get_detail_data'];
      const employeeType = employee.type;
      const account = {
        access: {},
        user_token: get(payloads, 'user_token', ''),
      };

      if (employeeType == 'DRIVER') {
        account.object_access = { shipments: 'BY_ASSIGNED_DRIVER' };
      }

      if (!isEmpty(password)) {
        account.plain_password = password;
      }

      const variables = {
        id: detailDataId,
        input: {
          username,
          full_name,
          email,
          type,
          account,
        },
      };

      if (!isEmpty(password)) {
        variables.input.password = password;
      }

      if (!isEmpty(company_id)) {
        variables.input.company_id = company_id;
      }

      if (!isEmpty(metadata)) {
        variables.input.metadata = metadata;
      }

      if (!isEmpty(address)) {
        variables.input.address = {
          country: get(address, 'country', ''),
          state: get(address, 'state', ''),
          city: get(address, 'city', ''),
          address1: get(address, 'address1', ''),
          address2: get(address, 'address2', ''),
          zip_code: get(address, 'zip_code', ''),
        };
      }

      return api({
        query,
        variables,
      }, 'update_user').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.user);
        return data.user;
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState, rootGetters }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const {
        username,
        full_name,
        password,
        email,
        type,
        company,
        metadata,
        address,
      } = payloads;

      const employee = rootGetters['employees/get_detail_data'];
      const employeeType = employee.type;
      const account = {
        access: {},
        plain_password: password,
        user_token: get(payloads, 'user_token', ''),
      };

      if (employeeType == 'DRIVER') {
        account.object_access = { shipments: 'BY_ASSIGNED_DRIVER' };
      }

      const variables = {
        input: {
          username,
          full_name,
          password,
          email,
          type,
          account,
        },
      };

      if (!isEmpty(company)) {
        variables.input.company_id = get(company, 'id');
      }

      if (!isEmpty(metadata)) {
        variables.input.metadata = metadata;
      }

      if (!isEmpty(address)) {
        variables.input.address = {
          country: get(address, 'country', ''),
          state: get(address, 'state', ''),
          city: get(address, 'city', ''),
          address1: get(address, 'address1', ''),
          address2: get(address, 'address2', ''),
          zip_code: get(address, 'zip_code', ''),
        };
      }

      const query = `
        mutation CreateUpdateUser($input: UserCreateInput) {
          user: create_user(input: $input) {
            id
            username
            full_name
            email
            type
            address {
              country
              state
              city
              address1
              address2
              zip_code
              latitude
              longitude
            }
            company {
              id
              name
              type
            }
            vehicle {
              reg_no
            }
            employee {
              name
              type
            }
            metadata
            created_at
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'create_user').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.user);
        return data.user;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    DELETE_DATA({ state, commit, rootState }, userId) {
      const id = !userId ? state.detailDataId : userId;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_user(id: ${id})
      }`;

      return api(mutation, 'delete_user').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    MOVE_ASSIGN_VEHICLE_DATA({ state, commit, rootState }, payloads) {
      const id = state.detailDataId;
      const { token } = rootState;
      const api = tmsApi.build(token);
      const { type, ids } = payloads;
      const typeValue = type === 'MANUAL' ? type : 'BY_VEHICLE_GROUP';
      const typeKey = type === 'MANUAL' ? 'vehicle_ids' : 'group_ids';
      const mutation = `mutation {
        assign_multiple_vehicle(id: ${id}, input: {
          type: ${typeValue}
          ${typeKey}: [${ids}]
        })
      }`;

      return api(mutation, 'assign_multiple_vehicle').then(({ data }) => {
        return data.assign_multiple_vehicle;
      }).catch(() => {
        commit('ADD_ERROR', 'MOVE_ASSIGN_VEHICLE_DATA');
      });
    },
    LOAD_USER_PREFERENCES({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { id: userId } = rootState.userData;
      const query = `{
        user(id: ${userId}) {
          preferences
        }
      }`;

      return api(query, 'load_user_preference').then(({ data }) => {
        const { preferences } = data.user;
        commit('ADD_PREFERENCES_DATA', preferences);
        return preferences;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_USER_PREFERENCES');
      });
    },
    UPDATE_USER_PREFERENCES({ state, commit, rootState }, payloads) {
      const api = tmsApi.build(rootState.token);
      const { key, value } = payloads;
      const { preferences } = state;

      preferences[key] = value;

      const { id } = rootState.userData;
      const input = {
        preference: preferences,
      };

      const variables = {
        id,
        input,
      };

      const query = `
        mutation UpdateUserPreferences($id: ID!, $input: UserUpdateInput) {
          user: update_user(id: $id, input: $input) {
            id
            username
            preferences
          }
        }
      `;

      return api({
        query,
        variables,
      }, 'update_user_preference').catch(() => {
        commit('ADD_ERROR', 'UPDATE_USER_PREFERENCES');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/users.js